import {loggedDel, loggedGet, loggedPost, dlGet, get, post} from '@/library/ajax'

const apiUrl = process.env.VUE_APP_API_EVENT_URL

export const addEvent = (data) => loggedPost(apiUrl + '/event', data)
export const updateProduct = (data) => loggedPost(apiUrl + '/event/product', data)
export const updateCoupon = (data) => loggedPost(apiUrl + '/event/coupon', data)
export const getEvent = (params) => loggedGet(apiUrl + '/event', params)
export const getProduct = (params) => loggedGet(apiUrl + '/event/product', params)
export const getCoupon = (params) => loggedGet(apiUrl + '/event/coupon', params)
export const getCouponList = (params) => loggedGet(apiUrl + '/event/coupon/list', params)
export const detailEvent = (id) => loggedGet(apiUrl + '/event/' + id, {})
export const detailProduct = (id) => loggedGet(apiUrl + '/event/product/' + id, {})
export const detailCoupon = (id) => loggedGet(apiUrl + '/event/coupon/' + id, {})
export const delEvent = (eventId) => loggedDel(apiUrl + '/event', { eventId })
export const delProduct = (productId) => loggedDel(apiUrl + '/event/product', { productId })
export const delCoupon = (couponId) => loggedDel(apiUrl + '/event/coupon', { couponId })
export const detailEventPublic = (eventId) => get(apiUrl + '/event/public/' + eventId, {})
export const setEventState = (data) => loggedPost(apiUrl + '/event/state', data)
export const importRegistrant = (data) => {
  return post(apiUrl + '/event/register/import', data)
}
export const exportRegistrant = (data) => dlGet(apiUrl + '/event/report/register/export', data)
export const exportAttendee = (data) => dlGet(apiUrl + '/event/report/attendee/export', data)
export const exportExhibitor = (data) => dlGet(apiUrl + '/event/report/exhibitor/export', data)
export const downloadInvoice = (billingId) => dlGet(apiUrl + '/event/register/invoice/download/' + billingId, {})
export const updatePhoto = (data) => post(apiUrl + '/event/report/register/photo/save', data)
export const updatePhotoAttendee = (data) => post(apiUrl + '/event/report/attendee/photo/save', data)